import { render, staticRenderFns } from "./LoansTable.vue?vue&type=template&id=20cf2c03"
import script from "./LoansTable.vue?vue&type=script&lang=js"
export * from "./LoansTable.vue?vue&type=script&lang=js"
import style0 from "./LoansTable.vue?vue&type=style&index=0&id=20cf2c03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports